import { render, staticRenderFns } from "./StepPageTemplate.vue?vue&type=template&id=6d0d2b6a&scoped=true"
import script from "./StepPageTemplate.vue?vue&type=script&lang=js"
export * from "./StepPageTemplate.vue?vue&type=script&lang=js"
import style0 from "./StepPageTemplate.vue?vue&type=style&index=0&id=6d0d2b6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0d2b6a",
  null
  
)

export default component.exports